export default "__VITE_ASSET__DwOr8V_t__"